import { render, staticRenderFns } from "./4cjq.vue?vue&type=template&id=98044c84&scoped=true&"
import script from "./4cjq.vue?vue&type=script&lang=js&"
export * from "./4cjq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98044c84",
  null
  
)

export default component.exports